import { Link, useLocation } from 'react-router-dom';
import { Camera, Search, HandHeart, BarChart3, LucideIcon } from 'lucide-react';

const STEPS: { id: string; path: string; name: string; owner: string; icon: LucideIcon }[] = [
  { id: 'publish', path: '/publish', name: '发布', owner: '张翰天', icon: Camera },
  { id: 'search', path: '/search', name: '寻找', owner: '肖淑慧', icon: Search },
  { id: 'pickup', path: '/pickup', name: '领取', owner: '高宇棋', icon: HandHeart },
  { id: 'stats', path: '/stats', name: '报告', owner: '高宇棋', icon: BarChart3 },
];

/**
 * 顶部流程指示器
 * - 4 步:发布 / 寻找 / 自助领取 / 报告
 * - 当前所在步骤高亮
 * - / 首页不显示(首页自己已有完整流程卡)
 */
export function StepIndicator() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const isDetail = pathname.startsWith('/item/');
  const isCandidates = pathname === '/search/results';
  if (isHome || isDetail || isCandidates) return null;

  const currentIdx = STEPS.reduce((best, s, i) => {
    if (pathname === s.path || pathname.startsWith(`${s.path}/`)) return i;
    return best;
  }, -1);

  return (
    <nav
      className="mb-3 flex items-center justify-between rounded-lg border border-slate-200 bg-white px-2 py-1.5 shadow-sm"
      aria-label="作品流程进度"
    >
      {STEPS.map((s, i) => {
        const Icon = s.icon;
        const isCurrent = i === currentIdx;
        const isDone = currentIdx > i && currentIdx >= 0;
        return (
          <Link
            key={s.id}
            to={s.path}
            className={`flex flex-1 flex-col items-center gap-0.5 rounded-md px-1 py-1 text-[10px] transition ${
              isCurrent
                ? 'bg-teamA-primary/10 text-teamA-primary'
                : isDone
                  ? 'text-teamA-primary/70 hover:bg-teamA-primary/5'
                  : 'text-slate-400 hover:text-slate-600'
            }`}
            title={`${s.name} · 责任:${s.owner}`}
          >
            <div className="flex items-center gap-1">
              <span
                className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-semibold ${
                  isCurrent
                    ? 'bg-teamA-primary text-white'
                    : isDone
                      ? 'bg-teamA-primary/70 text-white'
                      : 'bg-slate-200 text-slate-500'
                }`}
              >
                {i + 1}
              </span>
              <Icon className="h-3.5 w-3.5" />
            </div>
            <span className="font-medium">{s.name}</span>
          </Link>
        );
      })}
    </nav>
  );
}
